import DeliveryFeeModalContent from './DeliveryFeeModalContent'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'


const ModalWrapper = styled.div`
  .background--modal {
    &:before {
      background-color: #009bbf;
      cursor: pointer;
      content: "";
      height: 2px;
      position: absolute;
      transform: rotate(45deg);
      width: 24px;
      top: 20px;
      left: 20px;
    }

    &:after {
      background-color: #009bbf;
      content: "";
      cursor: pointer;
      height: 2px;
      position: absolute;
      transform: rotate(-45deg);
      width: 24px;
      top: 20px;
      left: 20px
    }
  }

  .card--modal {
    padding: 50px 30px 45px;
  }
`

const DeliveryFeeModal = ( { handleDeliveryFeeModal, showDeliveryFeeModal } ) => {
  return (
    <ModalWrapper>
      <Modal
        altura="auto"
        largura="350px"
        onShowModal={ handleDeliveryFeeModal }
        show={ showDeliveryFeeModal }
      >
        <DeliveryFeeModalContent handleDeliveryFeeModal={ handleDeliveryFeeModal } />
      </Modal>
    </ModalWrapper>
  )
}

DeliveryFeeModal.propTypes = {
  'handleDeliveryFeeModal': PropTypes.any.isRequired,
  'showDeliveryFeeModal': PropTypes.any.isRequired,
}

export default DeliveryFeeModal
